export default Object.freeze({
  emails: 1000,
  texts: 150,
  textsV2: 1000,
  events: 1000,
  tasks: 1000,
  contacts: 1000,
  campaigns: 1000,
  tags: 500,
});
